import React, { FunctionComponent } from "react";
import { NodeProps } from "reactflow";
import {
  BasicNodeLayout,
  DocumentSchemaSource,
  NodeSize,
  NodeType,
  NodeTypeCategory,
  NodeOperationIcon
} from "../Base";
import { DataType } from "../TypeDefinitions";
import { NodeConfigPropertyType } from "../../FlowDocument/PropertyTypeDefinitions";

const schemaProperty = "schemaId";
const schemaNameProperty = "schemaName";
const outputName = "object";

globalThis.nodeTypeDefinitions.setDefinition({
  nodeType: NodeType.objectUpdate,
  label: "Object Update",
  featureToggle: "feat-core-3221-flows-external-apis",
  operationIcon: NodeOperationIcon.update,
  category: NodeTypeCategory.transformations,
  controlOutputs: [],
  dataInputs: [{ name: "plexProcessFlowsInternalSource", label: "Object", type: DataType.OBJECT, mapsObject: true }],
  documentDataInputListName: "inputs",
  dataOutputs: [{ name: outputName, label: "object", type: DataType.OBJECT, hideLabel: true }],
  inputsSchemaProperties: {
    identifiersOnly: false,
    excludeIdentifiers: true,
    schemaPropertyName: schemaProperty,
    forceOptional: true
  },
  nodeConfigProperties: [
    {
      name: schemaProperty,
      label: "Object",
      propertyType: NodeConfigPropertyType.Schema,
      options: {
        changeSchemaOnConnection: true,
        excludeReferences: true,
        dataProperties: [outputName, "plexProcessFlowsInternalSource"],
        displayProperty: schemaNameProperty
      },
      schemaSourceSystemType: DocumentSchemaSource.schemaPicker
    },
    {
      name: schemaNameProperty,
      propertyType: NodeConfigPropertyType.NoInput
    },
    {
      name: "inputs",
      sectionName: "Fields",
      propertyType: NodeConfigPropertyType.EnabledInputs
    }
  ],
  size: NodeSize.Small,
  evaluate: (input, nodeProperties) => {
    const output: any = { ...(input.plexProcessFlowsInternalSource as any) };
    Object.keys(nodeProperties.inputs).forEach((fieldName) => {
      if (nodeProperties.inputs[fieldName].enabled && input[fieldName] !== undefined) {
        output[fieldName] = input[fieldName];
      }
    });
    return { output, activeControlHandleIds: [] };
  }
});

export const ObjectUpdateNode: FunctionComponent<NodeProps> = ({ id, data }) => {
  return <BasicNodeLayout id={id} data={data} />;
};
